import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Package } from "@phosphor-icons/react";
import api, { money } from "../../lib/api";
import { SectionHeader } from "../../components/shared";

export function Backorders() {
  const navigate = useNavigate();
  const { data: rows = [], isLoading } = useQuery({ queryKey: ["backorders"], queryFn: async () => (await api.get("/sales-orders/backorders")).data });
  return (
    <div>
      <SectionHeader title="Backorders" subtitle="Orders with quantities still to ship" />
      {isLoading ? (
        <div className="flex justify-center py-16"><div className="h-7 w-7 border-2 border-primary border-t-transparent rounded-full animate-spin" /></div>
      ) : rows.length === 0 ? (
        <div className="border border-border bg-card p-10 text-center text-muted-foreground" data-testid="backorders-empty">
          <Package size={34} className="mx-auto mb-3 opacity-40" />
          <p className="text-sm">No backorders — every order is fully shipped. 🎉</p>
        </div>
      ) : (
        <div className="space-y-3" data-testid="backorders-list">
          {rows.map((o) => (
            <div key={o.id} className="border border-border bg-card" data-testid="backorder-row">
              <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-border bg-secondary/30">
                <div className="flex items-center gap-3 flex-wrap">
                  <button onClick={() => navigate(`/sales/doc/${o.id}?tab=orders`)} data-testid="backorder-open" className="font-mono text-sm font-bold text-primary hover:underline">{o.doc_no}</button>
                  <span className="text-sm font-medium">{o.customer_name}</span>
                  {o.shipping_status && <span className="text-xs px-2 py-0.5 border border-blue-200 bg-blue-50 text-blue-700 rounded-sm">{o.shipping_status}</span>}
                  {o.requested_delivery_date && <span className="text-xs text-muted-foreground">Requested: {o.requested_delivery_date}</span>}
                </div>
                <div className="text-right">
                  <div className="text-xs text-muted-foreground">Outstanding</div>
                  <div className="tabular font-bold text-primary">{money(o.outstanding_value)}</div>
                </div>
              </div>
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left text-xs uppercase tracking-wider text-muted-foreground">
                    <th className="py-2 px-4 font-semibold">Item</th>
                    <th className="py-2 px-4 font-semibold text-right">Ordered</th>
                    <th className="py-2 px-4 font-semibold text-right">Shipped</th>
                    <th className="py-2 px-4 font-semibold text-right">Outstanding</th>
                  </tr>
                </thead>
                <tbody>
                  {o.lines.map((l, i) => (
                    <tr key={i} className="border-t border-border/60">
                      <td className="py-1.5 px-4">{l.description}</td>
                      <td className="py-1.5 px-4 text-right tabular text-muted-foreground">{l.quantity}</td>
                      <td className="py-1.5 px-4 text-right tabular text-muted-foreground">{l.qty_shipped}</td>
                      <td className="py-1.5 px-4 text-right tabular font-semibold text-amber-600">{l.outstanding}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
